export default __webpack_public_path__ + "static/IAK-2022-b8baf0f404a9a20ffe3e3b4ca2ffa675.png";